import React from "react";
import styled, { keyframes } from "styled-components";



// const DishImg = styled.img`
// flex: 0 0 96px;
// width: 96px;
// height: 96px;
// margin: 0;
// `;

const Dish = props => (
<div className="menu-dish">
    {/* <DishImg src={props.img} /> */}
    <div className="menu-dish__content">
        <h2 className="menu-dish__title">{props.title}</h2>
        <p className="menu-dish__description">{props.description}</p>
    </div>
</div>
)

export default Dish;


// WEBPACK FOOTER //
// ./src/components/menu-dish.js